import {connect} from 'react-redux';

import AdditionalScore from '../AdditionalScore.jsx';

function select(state, props) {
    const score = state.application.getIn(['live', 'scores', props.scoreId]);

    return {
        ...props,
        score
    };
}

export default connect(select)(AdditionalScore);



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/AdditionalScore.jsx